import { Alert, Button } from "react-bootstrap";

export default function PredictorSetupBanner({ onButtonClick, buttonText = "Set up Predictor" }) {
    return (
        <Alert variant="info" className="d-flex flex-column flex-xl-row align-items-xl-center justify-content-between gap-3">
            <div>
                <Alert.Heading className="h5">Predictor is not set up yet</Alert.Heading>
                <p>Predictor just got a massive upgrade! Your station, your rules.</p>
                <p>
                    You can now customize which sources Predictor uses, and how important each one of those is. You can even set predictor up to look for older
                    songs to fill up you backpool.
                </p>
                <p>
                    Need a hand setting it up? Reach out to us at{" "}
                    <a href="mailto:support@radioanalyzer.com" className="alert-link">
                        support@radioanalyzer.com
                    </a>
                </p>
            </div>
            <Button variant="ra-yellow" onClick={onButtonClick} className="text-nowrap">
                {buttonText}
            </Button>
        </Alert>
    );
}
